









import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import { EraSelection } from './utils';

@Component({})
export default class PayoutBanner extends Vue {
  @Prop() public availableEras!: EraSelection[];
  @Prop() public value!: number;

  @Emit('input')
  updateSelectedEra(selectedEra: number) {
    console.log(selectedEra);
    
    return selectedEra;
  }
}
